<cue-declarative-map-marker
  [className]="focused() ? 'map-active-item' : 'basicMarker'"
  pane="poi"
  [zIndexOffset]="focused() ? activeZIndexOffset : 0"
  [geoJson]="poi().geometry"
>
  <div
    *cueDeclarativeMapMarkerTemplate
    [class.map-active-item]="focused()"
    class="map-poi-host"
    (click)="onHostClick($event)"
    [style.transform]="'scale(' + scale() + ')'"
    [style.-webkit-transform]="'scale(' + scale() + ')'"
  >
    <ng-template #onlyName>
      <div class="poi onlyName">
        <span class="map-btn-name">{{ (poi().mapName | localizedString) || (poi().name! | localizedString) }}</span>
      </div>
    </ng-template>
    <ng-template #onlyImage>
      <div class="poi onlyImage">
        <img class="map-btn-icon-wrapper" [src]="poi()?.linkToImage | imageDimensions: { width: 50, height: 50 }" />
      </div>
    </ng-template>
    <ng-template #onlyCategoryIcon>
      <div class="poi onlyCategoryIcon">
        @if (poi().linkToIcon) {
          <cue-icon [icon]="poi()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
          <cue-icon [id]="generatedDomId" class="tempHidden" [icon]="ICONS.cueQrCode" />
        } @else {
          <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" customIconClass="map-btn-iconDef" />
        }
      </div>
    </ng-template>
    <ng-template #imageAndName>
      <div class="poi imageAndName">
        <span class="map-btn-name">{{ (poi().mapName | localizedString) || (poi().name! | localizedString) }}</span>
        <img class="map-btn-icon-wrapper" [src]="poi()?.linkToImage | imageDimensions: { width: 50, height: 50 }" />
      </div>
    </ng-template>
    <ng-template #codeAndName>
      <div class="poi codeAndName">
        <div class="poi onlyName">
          <span class="map-btn-name">{{ (poi().mapName | localizedString) || (poi().name! | localizedString) }}</span>
        </div>
        <div class="poi onlyCode">
          <span class="map-btn-name">{{ poi().qrCode }}</span>
        </div>
      </div>
    </ng-template>
    <ng-template #categoryIconAndName>
      <div class="poi categoryIconAndName">
        <span class="map-btn-name">{{ (poi().mapName | localizedString) || (poi().name! | localizedString) }}</span>
        @if (poi().linkToIcon) {
          <cue-icon [icon]="poi()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
        } @else {
          <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
        }
      </div>
    </ng-template>
    <ng-template #categoryIconAndImage>
      <div class="poi categoryIconAndImage">
        <img
          class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
          [src]="poi()?.linkToImage | imageDimensions: { width: 50, height: 50 }"
        />
        @if (poi().linkToIcon) {
          <cue-icon [icon]="poi()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
        } @else {
          <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" customIconClass="map-btn-iconDef" />
        }
      </div>
    </ng-template>
    <ng-template #onlyCode>
      <div class="poi onlyCode">
        <span class="map-btn-name">{{ poi().qrCode }}</span>
      </div>
    </ng-template>
    <ng-template #categoryIconAndCode>
      <div class="poi categoryIconAndName">
        <span class="map-btn-name">{{ poi().qrCode }}</span>
        @if (poi().linkToIcon) {
          <cue-icon [icon]="poi()?.linkToIcon" class="map-btn-icon-wrapper cue-icon" />
        } @else {
          <cue-icon class="map-btn-icon-wrapper" [icon]="ICONS.cueQrCode" [customIconClass]="'map-btn-iconDef'" />
        }
      </div>
    </ng-template>
    <div
      class="map-btn-container"
      [ngStyle]="{
        '--custom-rgb': customRgb(),
        '--custom-rgba': customRgba(),
        '--custom-rgba-saturated': customRgbaSaturated(),
        '--automatic-text-color': automaticTextColor(),
      }"
    >
      @if (!isActiveItem()) {
        @if (
          isDeploymentMode() && qrCodeShowSettingsForDeploymentMode() !== qrCodeShowOnFloorplanEnum.AccordingPoiSettings
        ) {
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CategoryIconName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CategoryIconCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CodeName) {
            <ng-container *ngTemplateOutlet="onlyName" />
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
        } @else {
          @if (poi().showOnFloorplan === showOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }

          @if (poi().showOnFloorplan === showOnFloorplanEnum.OnlyImage) {
            <ng-container *ngTemplateOutlet="onlyImage" />
          }

          @if (poi().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }

          @if (poi().showOnFloorplan === showOnFloorplanEnum.ImageAndName) {
            <ng-container *ngTemplateOutlet="imageAndName" />
          }

          @if (poi().showOnFloorplan === showOnFloorplanEnum.OnlyCategoryIcon) {
            <ng-container *ngTemplateOutlet="onlyCategoryIcon" />
          }

          @if (poi().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndImage) {
            <ng-container *ngTemplateOutlet="categoryIconAndImage" />
          }
          @if (poi().showOnFloorplan === showOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (poi().showOnFloorplan === showOnFloorplanEnum.CategoryIconAndCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (poi().showOnFloorplan === showOnFloorplanEnum.CodeAndName) {
            <ng-container *ngTemplateOutlet="codeAndName" />
          }
        }
      } @else {
        @if (
          isDeploymentMode() && qrCodeShowSettingsForDeploymentMode() !== qrCodeShowOnFloorplanEnum.AccordingPoiSettings
        ) {
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CategoryIconName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CategoryIconCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (qrCodeShowSettingsForDeploymentMode() === qrCodeShowOnFloorplanEnum.CodeName) {
            <ng-container *ngTemplateOutlet="codeAndName" />
          }
        } @else {
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndImage) {
            <ng-container *ngTemplateOutlet="categoryIconAndImage" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndName) {
            <ng-container *ngTemplateOutlet="categoryIconAndName" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.ImageAndName) {
            <ng-container *ngTemplateOutlet="imageAndName" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.OnlyCategoryIcon) {
            <ng-container *ngTemplateOutlet="onlyCategoryIcon" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.OnlyImage) {
            <ng-container *ngTemplateOutlet="onlyImage" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.OnlyName) {
            <ng-container *ngTemplateOutlet="onlyName" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.OnlyCode) {
            <ng-container *ngTemplateOutlet="onlyCode" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.CategoryIconAndCode) {
            <ng-container *ngTemplateOutlet="categoryIconAndCode" />
          }
          @if (poi().showOnFloorplanDetail === showOnFloorplanEnum.CodeAndName) {
            <ng-container *ngTemplateOutlet="codeAndName" />
          }
        }
      }
    </div>
  </div>
</cue-declarative-map-marker>
